// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoPortalGroupModel {
    static getAttributeTypeMap() {
        return PorticoPortalGroupModel.attributeTypeMap;
    }
}
PorticoPortalGroupModel.discriminator = undefined;
PorticoPortalGroupModel.additionalProperties = false;
PorticoPortalGroupModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
];
//# sourceMappingURL=porticoPortalGroupModel.js.map